import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import SidePanel from "../Components/SidePanel";
import customer from "../assets/images/customer.png";
import axios from "axios";

const Dashboard = () => {
  const [isCollapsed, setCollapsed] = useState(false);
  const [customerCount, setCustomerCount] = useState(0);

  const toggleSidePanel = () => {
    setCollapsed((prev) => !prev);
  };

  useEffect(() => {
    fetchCustomerCount();
  }, []);

  const fetchCustomerCount = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/superadmin/get_customers/`);
      if (response.status === 200) {
        setCustomerCount(response.data.length);
      }
    } catch (error) {
      console.error("Error fetching customer count:", error);
    }
  };

  return (
    <div>
      <Header toggleSidePanel={toggleSidePanel} />

      <div className="flex">
        <SidePanel isCollapsed={isCollapsed} />

        <main className="bg-[#282828] w-full min-h-screen overflow-hidden flex-1 p-6">
          <section className="flex justify-between items-center py-5">
            <h3 className="text-2xl font-semibold text-white">Dashboard</h3>
          </section>

          <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
            <div className="bg-[#E1204D] p-6 rounded-lg shadow-lg flex flex-col justify-between">
              <h2 className="text-lg text-white mb-4 font-medium">Customer Count</h2>
              <div className="flex justify-between items-center">
                <div className="border-8 border-[#A9173D] p-3 rounded-lg bg-[#E1204D]">
                  <img src={customer} alt="Customer Icon" className="w-8 h-8" />
                </div>
                <p className="text-4xl font-bold text-white">{customerCount}</p>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
